export const checklist_remark = {
  checklist: 'Checklist',
  address: 'Adres',
  returnButton: 'Terug naar de checklist',
  generalRemarkLabel: 'Algemene opmerkingen voor het gebouw',
  themeRemarkLabel: 'Algemene opmerkingen voor het thema',
};
